<template>
  <section class="flex">
    <div class="flex-fill">
      <Select
        v-model="station"
        :placeholder="$t('courseConnection.filters.station')"
        :options="availableStations"
        label="name"
      >
      </Select>
    </div>
    <Btn
      v-show="selectedStationFilter"
      variant="icon"
      class="mrgl-"
      @click="resetSelectedStationFilter"
    >
      <Icon id="cross" :scale="0.8" />
    </Btn>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Select from '@/components/ui/Select';

export default {
  name: 'ConnectionsFilters',
  components: {
    Select,
  },
  computed: {
    ...mapState('courses', [
      'selectedStationFilter',
      'courseConnectionsLocations',
    ]),
    station: {
      get() {
        return this.selectedStationFilter;
      },
      set(value) {
        this.setSelectedStationFilter(value);
      },
    },

    availableStations() {
      return Object.values(this.courseConnectionsLocations).map(location => ({
        id: location.id,
        name: location.name,
        value: location.sloid,
      }));
    },
  },
  methods: {
    ...mapActions('courses', [
      'setSelectedStationFilter',
      'resetSelectedStationFilter',
    ]),
  },
};
</script>

<style scoped></style>
